import { Button } from "@chakra-ui/react";
import React from "react";
import { Transaction } from "./Transaction";
import {Link} from 'react-router-dom'


export const TransactionList = ({ transactions }) => {
  const transactionsSort = [...transactions];
  return (
    <>
      <h3 style={{ margin: 20 }}>History</h3>
      {transactionsSort.length > 13 ? (
        <ul className="list">
          {transactionsSort
            .reverse()
            .slice(0, 12)
            .map((transaction) => (
              <Transaction key={transaction.id} transaction={transaction} />
            ))}
          <Button as={Link} to="/transactions">
            Show More
          </Button>
        </ul>
      ) : (
        <ul className="list">
          {transactionsSort
            .slice(0)
            .reverse()
            .map((transaction) => (
              <Transaction key={transaction.id} transaction={transaction} />
            ))}
        </ul>
      )}
    </>
  );
};
